import { arrayOrEmpty } from '@utils/util-helpers'

export const FINISHED_ONBOARDING_ACTIVITY_STATUSES = ['pending_verification', 'accepted', 'completed']
export const PROGRESS_SUBMISSION_STATUSES = ['pending_verification', 'accepted', 'rejected']

export function isOnboardingActivityFinished(activityOrStatus) {
  const status = typeof activityOrStatus === 'string' ? activityOrStatus : activityOrStatus?.status

  return FINISHED_ONBOARDING_ACTIVITY_STATUSES.includes(status)
}

export function isOnboardingActivitySubmittedForProgress(activity) {
  return Boolean(
    activity?.submittedAt ||
      activity?.dateCompleted ||
      PROGRESS_SUBMISSION_STATUSES.includes(activity?.submissionStatus) ||
      isOnboardingActivityFinished(activity)
  )
}

export function isRejectedOnboardingActivity(activityOrStatus) {
  if (typeof activityOrStatus === 'string') {
    return activityOrStatus === 'rejected'
  }

  return Boolean(activityOrStatus?.status === 'rejected' || activityOrStatus?.submissionStatus === 'rejected')
}

export function isOnboardingStepSubmittedForProgress(step) {
  const activities = arrayOrEmpty(step?.activities)

  return activities.length > 0 && activities.every(isOnboardingActivitySubmittedForProgress)
}

export function getHasActiveBrokerActivity(payload = {}) {
  return Boolean(payload.hasActiveBrokerActivity)
}

export function getOnboardingActivityContexts(onboarding = {}) {
  const categories = arrayOrEmpty(onboarding.categories || onboarding.onboarding?.categories)

  return categories.flatMap((category) =>
    arrayOrEmpty(category.checklists).flatMap((checklist) =>
      arrayOrEmpty(checklist.steps).flatMap((step) =>
        arrayOrEmpty(step.activities).map((activity) => ({
          category,
          checklist,
          step,
          activity,
        }))
      )
    )
  )
}

export function findOnboardingActivity(onboarding, activityId) {
  const id = String(activityId)

  return getOnboardingActivityContexts(onboarding).find(({ activity }) => String(activity.id) === id) || null
}

export function findFirstRejectedOnboardingActivityContext(onboarding = {}) {
  return (
    getOnboardingActivityContexts(onboarding).find(({ activity }) => isRejectedOnboardingActivity(activity)) || null
  )
}
